const ContactResource = function ($resource, ApiRequestParams, AppConfig) {
    return $resource(
        AppConfig.apiBaseUrl + 'contacts/',
        ApiRequestParams.defaults(),
        {
            update: {
                method: 'PUT',
                url: AppConfig.apiBaseUrl + 'contacts/:contactID'
            }
        }
    );
};

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = ContactResource;
}
